module.exports = __webpack_public_path__ + "static/media/Location01.c6f04652.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/SocialMediaMenu/Location01.svg
// module id = 334
// module chunks = 0